<template>
    <div class="optpl-template-item optpl-template-item__collection" :class="{ 'loaded': this.imageWasLoaded, 'faded': ! userHasTiers(item.tier_ids) }">
        <span :class="'optpl-template-item__mark optpl-template-item__tag optpl-template-item__tag-' + item.mark" v-if="item.mark">{{ item.mark.toUpperCase() }}</span>
        <div class="optpl-template-item__image-container" @click="this.$router.push({ name: 'collection', params: { uid: item.uid }})">
            <figure :style="'background-image: url(' + this.image + ')'"><img :src="this.image" alt="" @load="imageLoaded"></figure>
        </div>

        <!-- <p><small>{{ item.tier_ids }}</small></p>
        <p><small>{{ this.userHasTiers(item.tier_ids) }}</small></p> -->

        <div class="optpl-template-item__text">
            <h4>
                <span>{{ item.title ? item.title : 'Some Title' }}</span>
                <span class="optpl-template-item__price" v-if="item.price ">$199</span>
            </h4>
            <div class="optpl-template-item__description">{{ item.description_text ? item.description_text : item.description }}</div>

            <div class="optpl-template-item__overlay optpl-template-item__overlay-collection">
                <router-link :to="{ name: 'collection', params: { uid: item.uid }}" class="opui-btn opui-btn-secondary">
                    {{ $e('View Collection') }}
                </router-link>

                <UpgradeButton v-if="! userHasTiers(item.tier_ids)" />
            </div>
        </div>
    </div>
</template>

<script>
import UpgradeButton from './UpgradeButton.vue'

export default {
    components: { UpgradeButton },
    props: {
        item: { type: Object, required: true },
    },
    data() {
        return {
            imageWasLoaded: false,
        }
    },
    computed: {
        image() {
            let image = ''

            if (this.item.preview) image = this.item.preview
            if (this.item.preview_full) image = this.item.preview_full

            return image
        }
    },
    methods: {
        imageLoaded() {
            this.imageWasLoaded = true
        },
    },
}
</script>
